import { useEffect, useState, useRef } from "react";

const VolumeMeter = ({ audio1Ref, audio2Ref, isPlaying1, isPlaying2, gain1 = 1, gain2 = 1 }) => {
  const [level1, setLevel1] = useState(0);
  const [level2, setLevel2] = useState(0);
  const animationRef = useRef(null);

  useEffect(() => {
    const updateLevels = () => {
      // Simulated levels based on playback state and gain
      if (isPlaying1) {
        const baseLevel = 40 + Math.random() * 35;
        setLevel1(Math.min(100, baseLevel * gain1));
      } else {
        setLevel1(prev => prev * 0.85);
      }

      if (isPlaying2) {
        const baseLevel = 40 + Math.random() * 35;
        setLevel2(Math.min(100, baseLevel * gain2));
      } else {
        setLevel2(prev => prev * 0.85);
      }

      animationRef.current = requestAnimationFrame(updateLevels);
    };

    if (isPlaying1 || isPlaying2 || level1 > 1 || level2 > 1) {
      animationRef.current = requestAnimationFrame(updateLevels);
    }

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPlaying1, isPlaying2, gain1, gain2, level1, level2]);

  return (
    <div className="volume-meter-slim" data-testid="volume-meter">
      <div className="meter-column meter-1">
        <div className="meter-fill" style={{ height: `${level1}%` }} />
        <div className="meter-peak" style={{ bottom: `${Math.min(level1 + 5, 100)}%` }} />
      </div>
      <div className="meter-column meter-2">
        <div className="meter-fill" style={{ height: `${level2}%` }} />
        <div className="meter-peak" style={{ bottom: `${Math.min(level2 + 5, 100)}%` }} />
      </div>
    </div>
  );
};

export default VolumeMeter;
